<template>
  <div id="app">
      <GlobalNavBar />
      <b-container class="content">
        <b-row>
          <b-col sm="3"> 
              <LeftBar />
          </b-col>
          <b-col sm="9">
            <router-view/>
          </b-col>
        </b-row>
      </b-container>
      <Footer />
  </div>
</template>

<script>
import GlobalNavBar from './components/layout/GlobalNavBar'
import LeftBar from './components/layout/LeftBar'
import Footer from './components/layout/Footer'

export default {
  name: 'App',
  components: {
    GlobalNavBar,
    LeftBar,
    Footer
  }
}
</script>

<style>
#app {
  background: rgb(230, 238, 240);
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  align-content: center;
}

.content {
  padding-top: 30px; 
  padding-bottom: 30px;
}

h3 {
  padding-top: 16px;
}

hr {
  margin: 16px;
}
</style>
